<div class="row mb-3 dark-bg">
  <div class="row">

    <div class="row">
      <div class="col-md-12">
        <div class="card border-0 gray-bg">
          <div class="card-header border-0 transparent text-white d-flex justify-content-between">
            <span>By Track Session A</span>
          </div>
          <div class="card-body p-0">
            <div class="w-100 h-100p">
              <ngx-charts-advanced-pie-chart [view]="view" [gradient]="gradient" scheme="vivid" [animations]="animations" [results]="groupASession$ | async">
              </ngx-charts-advanced-pie-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card border-0 light-bg">
          <div class="card-header border-0 transparent text-white d-flex justify-content-between">
            <span>By Track Session B</span>
          </div>
          <div class="card-body p-0">
            <div class="w-100 h-100p">
              <ngx-charts-advanced-pie-chart [view]="view" [gradient]="gradient" scheme="forest" [animations]="animations" [results]="groupBSession$ | async">
              </ngx-charts-advanced-pie-chart>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12">
      <div class="row">
        <!-- <div class="col-md-12">
          <div class="card border-0 dark-bg">
            <div class="card-header border-0 transparent text-white d-flex justify-content-between">
              <span>By Country</span>
            </div>
            <div class="card-body p-0">
              <div class="w-100 h-100p">
                <ngx-charts-bar-vertical [view]="view" scheme="vivid" [animations]="animations" [results]="country$ | async">
                </ngx-charts-bar-vertical>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="col-md-12">
          <div class="card border-0 dark-bg">
            <div class="card-header border-0 transparent text-white d-flex justify-content-between">
              <span>By Gender</span>
            </div>
            <div class="card-body p-0">
              <div class="w-100 h-100p">
                <ngx-charts-pie-grid [view]="view" scheme="fire" [animations]="animations" [results]="gender$ | async">
                </ngx-charts-pie-grid>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/admin/bottom-panel/bottom-panel.component.html